import React, { useContext } from 'react';
import c from 'classnames';
import CommentBox from '../../../CommentBox/presets/CommentBox';
import { CommentContext } from '../../CommentContext';
import { useReplyCommentBoxBase } from './useReplyCommentBoxBase';
import s from './ReplyCommentBox.scss';
/** Our `CommentBox` with some comment specific props passed through. */ const ReplyCommentBox = ({ canPostComment , className , nc , onReplyPosted  })=>{
    const { id , onCancel , onPublishSuccess  } = useReplyCommentBoxBase({
        onPublishSuccess: onReplyPosted
    });
    const { comment  } = useContext(CommentContext);
    return /*#__PURE__*/ React.createElement(CommentBox, {
        id: id,
        className: c(s['root'], className),
        commentableType: comment.typeId,
        commentableItemId: comment.itemId,
        replyComment: comment,
        autoFocus: true,
        canPostComment: !!canPostComment,
        nc: nc,
        onPublishSuccess: onPublishSuccess,
        onClose: onCancel
    });
};
ReplyCommentBox.displayName = 'ReplyCommentBox';
export default ReplyCommentBox;
